import StaffDetailPage from '../../../components/admin/staff/StaffDetailPage'

export default function StaffMemberDetail() {
  return <StaffDetailPage />
}
